{
    "generic": "Noget gik galt. Prøv igen.",
    "notFound": "Vi kunne ikke finde det, du ledte efter."
}
